import { useCallback, useState } from "react";
import productService from "../services/productService";
import { downloadImage, handleShareKit } from "../utils/Utils";

export const useFeatureActions = ({ tryonId, productTitle }) => {
  const [isShareLoading, setIsShareLoading] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [likeLoading, setLikeLoading] = useState(false);
  const [isLiked, setIsLiked] = useState(true);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const handleShareLink = useCallback(async () => {
    if (!tryonId) {
        return
    }
    try {
      setIsShareLoading(true);
      let url = shareLink;
      if (!url) {
        const res = await productService.getShareableLink(tryonId);
        url = Object.values(res?.data?.sharedUrls)?.[0] || "";
        setShareLink(url);
      }
      const shareText = `I just tried the ${productTitle} on with Swan. See my Try-On: ${url}`;
      handleShareKit(url, shareText);
    } catch (error) {
      console.error("Error sharing link:", error);
    } finally {
      setIsShareLoading(false);
    }
  }, [shareLink, productTitle, tryonId]);

  const handleLike = useCallback(async () => {

    if (!tryonId) {
        return
    }
    try {
      setLikeLoading(true);
      await productService.handleProductShareFeedback({
        tryonId,
        feedback: isLiked ? "like" : "dislike",
      });
      setIsLiked((prev) => !prev);
    } catch (error) {
      console.error("Error liking item:", error);
    } finally {
      setLikeLoading(false);
    }
  }, [isLiked, tryonId]);

  const handleDownload = useCallback(async () => {
    if (!tryonId) {
        return
    }
    setIsDownloadLoading(true);
    try {
      let url = shareLink;
      if (!url) {
        const res = await productService.getShareableLink(tryonId);
        url = Object.values(res?.data?.sharedUrls)?.[0] || "";
        setShareLink(url);
      }
      downloadImage(url, productTitle);
    } catch (error) {
      console.error("Error downloading image:", error);
    } finally {
      setIsDownloadLoading(false);
    }
  }, [shareLink, productTitle, tryonId]);

  return {
    handleShareLink,
    handleLike,
    handleDownload,
    isShareLoading,
    likeLoading,
    isDownloadLoading,
    isLiked,
  };
};
